/* ─────────────────────────────────────────────────────────────────────────────
   assets/sticky-atc-co.js — "Agregar al carrito" ADHESIVO en las fichas NORMALES
   (dueño 11-sep §19.9).

   QUIÉN LO INCLUYE: `tema-redisenio/sections/main-product.liquid`, y SÓLO cuando el
   producto NO es el 2x1 (`cco_suf != 'cod-co'`) y NO es la vitrina del Colibrí
   (`cco_vitrina == false`) — los MISMOS dos flags que ya gobiernan el resto del gate
   de contra entrega en ese archivo, no una condición nueva. Este archivo lleva,
   además, sus PROPIAS guardas por si algún día se incluye en más de un sitio (ver
   más abajo): nunca corre donde ya hay una píldora de contra entrega.

   QUÉ HACE, en una frase: aparece pegado abajo cuando el botón nativo "Agregar al
   carrito" sale de pantalla hacia arriba, y al tocarlo agrega al carrito de Shopify
   por `/cart/add.js` — directo si el producto no tiene variantes, o abriendo una
   ventanita rápida (chips + cantidad) si las tiene.

   🔒 NO SE REIMPLEMENTA LA RESOLUCIÓN DE VARIANTE DEL TEMA. Dawn ya pinta, para
   cualquier producto con más de una variante, un `<variant-radios>` o
   `<variant-selects>` con el JSON completo de `product.variants` adentro (mismo
   marcado que main-product.liquid ya emite para su propio selector). Se LEE ese
   JSON y esos mismos <fieldset>/<select> —nunca se toca el selector nativo, nunca se
   dispara su `fetch` de re-render— y la variante se resuelve por CLAVE
   (`option1`/`option2`/`option3`, en el mismo orden que declara el DOM), el mismo
   patrón que ya usa el resto del repo (`resolverVarianteCo`). Así el flujo queda
   HERMÉTICO y comprobable con un fixture, sin depender del JS del tema (que no vive
   en este repo).

   🔒 SI ALGO NO EMPAREJA, NO SE INVENTA NADA: sin el botón nativo, sin su `<form>` o
   sin su `input[name="id"]`, este archivo no hace nada — la ficha se queda como
   estaba. Y si la combinación de chips que el cliente arma no tiene variante real,
   el botón "Agregar" de la ventanita se apaga con un aviso, nunca manda un id
   inventado.

   🔓 ÚNICA EXCEPCIÓN DECLARADA a "nunca se toca el selector nativo" (revisión
   adversaria, hallazgo H2): tras un POST exitoso desde la ventanita, SÍ se escribe
   en el picker nativo — se marca el radio/option que el cliente YA eligió en
   NUESTRA ventanita y se dispara UN 'change' (bubbles:true) para que Dawn
   re-sincronice precio/imagen/`input[name="id"]` por su propio mecanismo
   (`VariantSelects.onVariantChange` → `renderProductInfo`/`updateVariantInput`,
   verificado en el `global.js` vivo del tema). No es una regresión de la regla de
   arriba: la RESOLUCIÓN de la variante sigue siendo 100% nuestra (leerVariantes +
   resolverVariante, nunca delegada al tema) — esto solo AVISA al tema, DESPUÉS del
   hecho, de una elección que ya está tomada, para que la ficha deje de mostrar una
   selección vieja (ej. seguir mostrando "Dama" arriba cuando el cliente agregó
   "Caballero" por la ventanita). Va en `try/catch` y SIEMPRE después del POST
   exitoso: si el tema cambia y esto falla, el pedido YA se agregó — el fallo es
   silencioso y nunca rompe el cierre de la ventanita.

   Sin fotos. Un solo emoji en toda la pieza (🛒, en el botón adhesivo, AL FINAL del
   texto — mismo lugar que el botón nativo "Agregar al Carrito 🛒"). Sin `rem`.

   ═══ CASOS 8 y 10 (dueño 22-sep, decisión CERRADA del orquestador) ═══════════
   Ya NO hay toast. Tras un POST exitoso a `/cart/add.js` — en las DOS rutas, la
   directa (sin variantes) y la de la ventanita (con variantes) — el botón que se
   tocó muestra «Agregado ✓» ~500ms y la página se va a `/cart` (Caso 10: ir
   directo al carrito, que ya es un paso más del embudo de esta tienda, en vez de
   quedarse en la ficha con un aviso flotante que se le montaba encima al círculo
   de WhatsApp — ese era el Caso 8). La redirección pasa SIEMPRE por `ir()`, que
   usa `window.__satcIr` sólo si además `window.__satcPruebas === true` (la
   costura que la suite usa para interceptar sin navegar de verdad, con un
   segundo candado para que un global de nombre libre de otra de las apps de la
   tienda no pueda secuestrarla por accidente) y si no, `window.location.assign`.

   Antes de irse, se sincroniza el contador del ícono del carrito de la cabecera
   (`#cart-icon-bubble`, Dawn) por la Section Rendering API
   (`?sections=cart-icon-bubble`), con fallback a `/cart.js` → `item_count` si esa
   llamada falla. El fallo del fallback también se traga en silencio: el badge es
   cosmético — la compra YA se hizo — y nunca debe bloquear el regreso al carrito.
   La espera por esa sincronía está ACOTADA (`TOPE_SINCRONIA_MS`, 1200ms): un
   `fetch` que se cuelga sin fallar ni resolver (no simulable con "falla", el
   modo de falla real) ya no puede dejar al cliente enterrado en la ficha para
   siempre — revisión adversaria, 22-sep (ALTO-1). Y mientras esa espera corre,
   un pestillo (`yendoAlCarrito`) impide que tocar otro chip de la ventanita
   re-habilite el botón y dispare un SEGUNDO `/cart/add.js` — mismo día (ALTO-2).
   ───────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // ── GUARDAS DE ENTORNO ────────────────────────────────────────────────────
  // El gate de Liquid ya decide si este <script> se incluye; esto es el cinturón,
  // por si el día de mañana se incluyera en más de una plantilla por error. SÓLO
  // se excluye la píldora de contra entrega DE LA LANDING (`.lb-atc--cod-pill`,
  // el 2x1 — la que trae `.cco-atc` a su lado, sección (2) de este trabajo): ésa
  // es la única CTA que el dictado del dueño protege como "el sticky COD sigue
  // igual, no le sumes otro".
  // 🔒 NO se excluye `[data-cco-root]` (el formulario de contra entrega EN
  // FICHAS NORMALES, `cco_va`): medido en vivo el 11-sep, `brazalete-amazonita`
  // —el ejemplo que el propio dueño dio de "ficha normal"— TIENE ese formulario
  // Y "Agregar al Carrito" nativo a la vez; las dos CTAs conviven en la página
  // hoy, así que el botón adhesivo tiene que convivir con ellas también.
  if (document.querySelector('.lb-atc--cod-pill') || document.querySelector('.cco-atc')) return;

  var submit = document.querySelector('.product-form__submit');
  if (!submit) return;
  var form = submit.closest('form');
  if (!form) return;
  var idInput = form.querySelector('input[name="id"]');
  if (!idInput) return;
  // Doble inclusión (dos secciones de producto en la misma página, o el archivo
  // repetido a mano): un segundo botón adhesivo encima del primero es peor que
  // ninguno.
  if (document.querySelector('.satc-bar')) return;
  // 🔒 TAREA ADHESIVO (dueño 11-sep, ENDURECIDO tras revisión adversaria — H4): si
  // el botón NATIVO nace deshabilitado, la barra se apaga SOLO cuando de verdad no
  // hay forma de que eso cambie sin recargar la página: producto SIN selector de
  // variantes (una sola variante, agotada). Un producto CON `<variant-radios>` o
  // `<variant-selects>` SIEMPRE construye la barra, aunque la combinación por
  // defecto nazca agotada (ej. un deep-link `?variant=<id agotado>`, que Dawn
  // preselecciona con el botón nativo `disabled` puesto) — la disponibilidad REAL
  // para esos productos no se lee de `submit.disabled` en ningún punto de este
  // archivo (ver `disponibilidadActual()` más abajo): leerlo aquí, una sola vez,
  // metería la carrera de Dawn (deshabilita SÍNCRONO en su 'change', rehabilita
  // ASÍNCRONO ~1-1.5s después, tras el fetch de `renderProductInfo`) — verificado
  // en vivo el 16-sep contra `brazalete-renovacion-interior?variant=<Caballero
  // agotado>`: sin este cambio, la barra nunca se pintaba en el resto de esa carga
  // de página, ni siquiera después de elegir "Dama" (disponible) en el picker.
  var datosInicio = leerVariantes(); // null si el producto no tiene selector de variantes
  if (!datosInicio && submit.disabled) return; // único caso sin forma de cambiar

  /* ═══════════════════════════════════════════════════════════════════════
     (A) LAS VARIANTES, LEÍDAS DEL MARCADO QUE DAWN YA PINTA
     ═══════════════════════════════════════════════════════════════════════ */

  function textoLimpio(el) {
    return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  // Devuelve { opciones: [{nombre, valores:[{valor,texto,elegido,agotado}]}],
  //            variantes: [ {id, available, option1, option2, option3, ...}, … ] }
  // o `null` si el producto no tiene selector de variantes (una sola variante).
  function leerVariantes() {
    var cajaRadios = document.querySelector('variant-radios');
    var cajaSelect = cajaRadios ? null : document.querySelector('variant-selects');
    var caja = cajaRadios || cajaSelect;
    if (!caja) return null;

    var scriptJson = caja.querySelector('script[type="application/json"]');
    var variantes = [];
    if (scriptJson) {
      try { variantes = JSON.parse(scriptJson.textContent || '[]') || []; } catch (e) { variantes = []; }
    }
    if (!Array.isArray(variantes) || !variantes.length) return null;

    var opciones = [];
    if (cajaRadios) {
      var fieldsets = cajaRadios.querySelectorAll('fieldset');
      for (var i = 0; i < fieldsets.length; i++) {
        var fs = fieldsets[i];
        var inputs = fs.querySelectorAll('input[type="radio"]');
        var valores = [];
        for (var j = 0; j < inputs.length; j++) {
          var inp = inputs[j];
          var lab = inp.id ? fs.querySelector('label[for="' + inp.id + '"]') : null;
          valores.push({
            valor: inp.value,
            texto: textoLimpio(lab) || inp.value,
            elegido: !!inp.checked,
            agotado: !!inp.disabled,
          });
        }
        if (valores.length) {
          opciones.push({ nombre: textoLimpio(fs.querySelector('legend')) || ('Opción ' + (i + 1)), valores: valores });
        }
      }
    } else {
      var drops = cajaSelect.querySelectorAll('.product-form__input--dropdown');
      for (var k = 0; k < drops.length; k++) {
        var sel = drops[k].querySelector('select');
        if (!sel) continue;
        var valores2 = [];
        for (var m = 0; m < sel.options.length; m++) {
          var op = sel.options[m];
          valores2.push({
            valor: op.value,
            texto: textoLimpio(op) || op.value,
            elegido: !!op.selected,
            agotado: !!op.disabled,
          });
        }
        if (valores2.length) {
          opciones.push({ nombre: textoLimpio(drops[k].querySelector('label')) || ('Opción ' + (k + 1)), valores: valores2 });
        }
      }
    }
    if (!opciones.length) return null;
    return { opciones: opciones, variantes: variantes };
  }

  // Empareja por CLAVE (option1/2/3, en el orden de `opciones`) — nunca por índice
  // suelto, para no depender de que el orden de las variantes coincida con nada.
  function resolverVariante(datos, elegidos) {
    var vs = datos.variantes;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      var ok = true;
      for (var k = 0; k < elegidos.length; k++) {
        var campo = 'option' + (k + 1);
        if (elegidos[k] == null || String(v[campo]) !== String(elegidos[k])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  // Disponibilidad de la combinación ACTUAL — usada para decidir si la barra se
  // MUESTRA (sección B), nunca si se CONSTRUYE (eso ya lo decide el guard de
  // arriba, una sola vez). CON selector: se resuelve por el DOM vivo, síncrono,
  // por la MISMA vía que ya usa la ventanita (leerVariantes+resolverVariante) —
  // nunca por `submit.disabled`, que es justo lo que evita la carrera de Dawn
  // descrita arriba: cuando el picker nativo dispara 'change', el navegador ya
  // actualizó `checked`/`selected` de forma síncrona ANTES de que cualquier
  // listener (el nuestro o el de Dawn) se ejecute, así que leer el DOM aquí es
  // siempre inmediato y correcto, sin esperar el fetch async de Dawn. SIN
  // selector: `submit.disabled` es la ÚNICA fuente posible y es estable (nada
  // puede cambiarla sin recargar, porque no hay picker que dispare 'change').
  function disponibilidadActual() {
    var datos = leerVariantes();
    if (!datos) return !submit.disabled;
    var elegidos = datos.opciones.map(function (op) {
      for (var i = 0; i < op.valores.length; i++) { if (op.valores[i].elegido) return op.valores[i].valor; }
      return op.valores.length ? op.valores[0].valor : null;
    });
    var variante = resolverVariante(datos, elegidos);
    return !!variante && variante.available !== false;
  }

  /* ═══════════════════════════════════════════════════════════════════════
     (B) LA BARRA ADHESIVA — aparece cuando el botón nativo ya quedó ARRIBA
     ═══════════════════════════════════════════════════════════════════════
     IntersectionObserver, no un cálculo de scroll a mano: sólo se enciende cuando
     el nativo salió por ARRIBA (ya se pasó de largo yendo hacia abajo), nunca
     mientras todavía no se llega a él (más abajo en la página) — de eso depende
     `boundingClientRect.top < 0`, que distingue las dos direcciones. */
  var bar = document.createElement('div');
  bar.className = 'satc-bar';
  bar.setAttribute('data-satc-bar', '1');
  bar.innerHTML = '<button type="button" class="satc-btn" data-satc-abrir>'
    // 🔒 H6: emoji AL FINAL del texto — mismo lugar que el botón nativo
    // ("Agregar al Carrito 🛒", verificado en vivo), no antes.
    + '<span class="satc-btn__txt">Agregar al carrito</span>'
    + '<span class="satc-btn__ico" aria-hidden="true">🛒</span>'
    + '</button>'
    // 🔒 TAREA ADHESIVO: mensaje VISIBLE en la barra si el POST falla — nunca
    // silencio. Arranca oculto. (Caso 8/10: el aviso de ÉXITO ya no vive aquí —
    // el toast se quitó; el éxito lo dice el propio botón, ver sección (C).)
    + '<p class="satc-bar__msg" data-satc-bar-msg hidden>No se pudo agregar, intenta de nuevo</p>';
  document.body.appendChild(bar);
  var btnBar = bar.querySelector('[data-satc-abrir]');
  var barMsg = bar.querySelector('[data-satc-bar-msg]');
  var barMsgTimer = null;
  function mostrarErrorBarra() {
    barMsg.hidden = false;
    clearTimeout(barMsgTimer);
    barMsgTimer = setTimeout(function () { barMsg.hidden = true; }, 4000);
  }

  // 🔒 TAREA ADHESIVO (H4, endurecido): "pasarse de largo" ya NO es la única
  // condición para mostrarse — también hace falta que la combinación ACTUAL esté
  // disponible (`disponibilidadActual()`, arriba). `yaPaso` guarda sólo el estado
  // de scroll; `actualizarBarra()` combina las dos señales cada vez que CUALQUIERA
  // de ellas pudo cambiar.
  var yaPaso = false;
  function actualizarBarra() {
    bar.classList.toggle('is-visible', yaPaso && disponibilidadActual());
  }
  if (typeof IntersectionObserver === 'function') {
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (!e) return;
      yaPaso = !e.isIntersecting && e.boundingClientRect.top < 0;
      actualizarBarra();
    }, { threshold: 0 });
    io.observe(submit);
  } else {
    // Sin IntersectionObserver (navegador muy viejo): se queda visible siempre en
    // vez de invisible siempre — molesta menos que un botón que nunca aparece.
    yaPaso = true;
    actualizarBarra();
  }
  // 🔒 TAREA ADHESIVO (H4, "decide al MOSTRAR… en cada 'change' del picker
  // nativo"): si el cliente cambia de variante en el selector NATIVO (no en
  // nuestra ventanita) mientras la barra ya está a la vista, la disponibilidad se
  // re-evalúa de inmediato — sin esperar a que Dawn termine su propio re-render
  // async, porque `disponibilidadActual()` no depende de eso (arriba). Un solo
  // listener en `document`, filtrado por `closest`, cubre las dos vías
  // (`<variant-radios>`/`<variant-selects>`) sin acoplarse a su marcado interno.
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('variant-radios, variant-selects')) actualizarBarra();
  });

  /* ═══════════════════════════════════════════════════════════════════════
     (C) EL POST A /cart/add.js — el mismo para las dos rutas (con y sin ventanita)
     ═══════════════════════════════════════════════════════════════════════ */
  function agregarAlCarrito(variantId, cantidad, botonOrigen, alExito) {
    botonOrigen.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: cantidad }] }),
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        botonOrigen.disabled = false;
        if (typeof alExito === 'function') alExito();
      })
      .catch(function () {
        botonOrigen.disabled = false;
        if (typeof alExito === 'function') alExito(false);
      });
  }

  // 🔒 CASO 10: la ÚNICA salida de este archivo hacia otra página. `window.__satcIr`
  // es la costura para que la suite intercepte sin navegar de verdad; sin ella
  // (producción), es `window.location.assign` — nunca `.href` ni `.replace`, para
  // que "Atrás" del navegador siga funcionando después de llegar al carrito.
  // 🔒 REVISIÓN ADVERSARIA (BAJO): la costura sólo se honra si `window.__satcPruebas`
  // vale exactamente `true` — un global de nombre libre (`__satcIr`) que CUALQUIER
  // script de las apps que carga la tienda (11 apps, ver `docs/contexto-colombia/
  // 02-reglas-del-dueno.md`) podría definir sin querer, secuestrando la ÚNICA salida
  // de este archivo en producción. La suite pone las dos.
  function ir(url) {
    var costura = (window.__satcPruebas === true && typeof window.__satcIr === 'function') ? window.__satcIr : null;
    if (costura) { costura(url); return; }
    window.location.assign(url);
  }

  // 🔒 CASO 10: réplica de `CartDrawerItems.getSectionInnerHTML` (Dawn,
  // `assets/cart-drawer.js` del tema vivo, verificado el 22-sep): la Section
  // Rendering API devuelve `{"cart-icon-bubble": "<div id=\"shopify-section-…\"
  // class=\"shopify-section\">…</div>"}` — se parsea, se toma `.shopify-section`
  // (el envoltorio que Shopify AGREGA solo, no algo que emita
  // `sections/cart-icon-bubble.liquid`) y su `innerHTML` reemplaza el de
  // `#cart-icon-bubble` (el propio `<a>` del ícono, verificado en
  // `sections/header.liquid` del tema vivo: no hay una capa intermedia que
  // envolver). Si algo no calza (fetch caído, JSON roto, sección vacía, el
  // envoltorio ausente), se cae al fallback de `/cart.js` — nunca se deja el
  // badge a medio pintar con basura.
  function sincronizarBadgeCarrito() {
    var icono = document.getElementById('cart-icon-bubble');
    if (!icono) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (datos) {
        var html = datos && datos['cart-icon-bubble'];
        if (!html) throw new Error('satc: sección cart-icon-bubble vacía');
        var seccion = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (!seccion) throw new Error('satc: falta .shopify-section en la respuesta');
        icono.innerHTML = seccion.innerHTML;
        animarBadge(icono);
      })
      .catch(function () { return sincronizarBadgeCarritoFallback(icono); });
  }

  // Reinicia la animación de pulso (Caso 10) aunque ya estuviera puesta de una
  // sincronía anterior: se quita, se fuerza un reflow (`offsetWidth`, el truco
  // estándar para que el navegador "olvide" que la animación ya corrió) y se
  // vuelve a poner. `.cart-count-bubble` puede no existir (carrito vacío: ni Dawn
  // ni el fallback la pintan) — entonces no hay nada que animar.
  function animarBadge(icono) {
    var burbuja = icono && icono.querySelector('.cart-count-bubble');
    if (!burbuja) return;
    burbuja.classList.remove('satc-badge-pulso');
    void burbuja.offsetWidth;
    burbuja.classList.add('satc-badge-pulso');
  }

  // Fallback declarado (Caso 10): sin el HTML real de Dawn, se REARMA a mano sólo
  // lo mínimo que `.cart-count-bubble` necesita para verse bien — nunca se
  // reimplementa el ícono completo. `item_count === 0` no es "el número 0": Dawn
  // no pinta ninguna burbuja con el carrito vacío (`{%- if cart != empty -%}` en
  // `sections/cart-icon-bubble.liquid`), así que aquí tampoco.
  function sincronizarBadgeCarritoFallback(icono) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (carrito) {
        pintarBadgeFallback(icono, carrito && carrito.item_count);
        animarBadge(icono);
      })
      .catch(function () { /* el badge se queda como estaba — nunca a medias */ });
  }

  function pintarBadgeFallback(icono, cuenta) {
    var n = Number(cuenta) || 0;
    var burbuja = icono.querySelector('.cart-count-bubble');
    if (n <= 0) {
      if (burbuja) burbuja.remove();
      return;
    }
    if (!burbuja) {
      burbuja = document.createElement('div');
      burbuja.className = 'cart-count-bubble';
      icono.appendChild(burbuja);
    }
    var span = burbuja.querySelector('span[aria-hidden="true"]');
    if (n < 100) {
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        burbuja.insertBefore(span, burbuja.firstChild);
      }
      span.textContent = String(n);
    } else if (span) {
      span.remove();
    }
    // 🔒 REVISIÓN ADVERSARIA (BAJO-1): Dawn SIEMPRE deja un span
    // `.visually-hidden` con el conteo, aunque el número visible se oculte
    // (≥100) — sin él, este rescate mínimo nunca anuncia el carrito a un
    // lector de pantalla. Se añade/actualiza SIEMPRE, no sólo cuando n<100, así
    // que `.cart-count-bubble` nunca queda `:empty` (Dawn la escondería).
    var oculto = burbuja.querySelector('span.visually-hidden');
    if (!oculto) {
      oculto = document.createElement('span');
      oculto.className = 'visually-hidden';
      burbuja.appendChild(oculto);
    }
    oculto.textContent = n + (n === 1 ? ' producto en el carrito' : ' productos en el carrito');
  }

  // 🔒 REVISIÓN ADVERSARIA (ALTO-2): pestillo de un solo uso. Sin él, mientras
  // `agregarExitoso` espera (ALTO-1, hasta `TOPE_SINCRONIA_MS`), la ventanita
  // seguía viva y un chip tocado durante la espera llamaba a `revisarVariante()`,
  // que RE-HABILITABA el botón que este archivo ya había apagado — y un segundo
  // clic disparaba un SEGUNDO `/cart/add.js` con otra variante (doble pedido en
  // contra entrega). Una vez que se entra a `agregarExitoso`, ningún chip vuelve
  // a tocar el botón (`revisarVariante`, más abajo, corta al toque si esto es
  // `true`) — no hace falta reiniciarlo: la única salida de aquí es `ir('/cart')`.
  var yendoAlCarrito = false;

  // 🔒 REVISIÓN ADVERSARIA (ALTO-1): el redirect esperaba la sincronía del badge
  // SIN TOPE — un `fetch('?sections=cart-icon-bubble')` que se cuelga (no falla,
  // simplemente no responde) dejaba al cliente enterrado en la ficha para
  // siempre, con el botón apagado diciendo «Agregado ✓» y sin ninguna salida (el
  // toast, que daba una vía alterna, ya no existe — Caso 8). `sincroniza` nunca
  // RECHAZA (sus dos niveles de fallback terminan en `catch` mudo), pero eso sólo
  // cubre el rechazo, no el estancamiento — `fetch` no trae timeout propio. Con
  // `Promise.race` contra `TOPE_SINCRONIA_MS`, el redirect sigue esperando la
  // sincronía cuando es razonablemente rápida (así N4 —sincronía retrasada
  // 700ms, por debajo del tope— sigue midiendo una espera real) pero nunca más
  // allá del tope: peor caso, `~max(500, TOPE_SINCRONIA_MS)`, nunca "para
  // siempre". `/cart` de todos modos vuelve a pintar la cabecera con el número
  // correcto en el servidor (Shopify re-renderiza `cart-icon-bubble` ahí), así
  // que un badge que no llegó a sincronizar en el cliente no pierde nada.
  var TOPE_SINCRONIA_MS = 1200;

  // 🔒 CASO 8/10: el ÚNICO desenlace de éxito de las DOS rutas. El botón que se
  // tocó pasa a decir «Agregado ✓», se sincroniza el badge de la cabecera (con
  // tope), y recién entonces se va a `/cart` — "antes de redirigir" es literal:
  // el `Promise.all` espera a las dos cosas (el mínimo de ~500ms Y la sincronía
  // acotada), nunca sólo dispara el fetch y se va.
  function agregarExitoso(boton) {
    if (yendoAlCarrito) return;
    yendoAlCarrito = true;
    boton.disabled = true;
    boton.textContent = 'Agregado ✓';
    // Complementario (UX): la ventanita deja de ser interactiva mientras se va —
    // no evita por sí solo el doble pedido (un `.click()` programático ignora
    // `pointer-events`, por eso el pestillo de arriba es lo que de verdad
    // protege), pero un toque real ya no hace nada visible.
    if (modal && !modal.hidden) modal.style.pointerEvents = 'none';
    var minimo = new Promise(function (r) { setTimeout(r, 500); });
    var sincroniza = sincronizarBadgeCarrito();
    var tope = new Promise(function (r) { setTimeout(r, TOPE_SINCRONIA_MS); });
    Promise.all([minimo, Promise.race([sincroniza, tope])]).then(function () { ir('/cart'); });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     (D) LA VENTANITA RÁPIDA — sólo se construye si el producto tiene variantes
     ═══════════════════════════════════════════════════════════════════════ */
  var modal = null, contOpciones = null, elCant = null, btnAgregar = null, elAviso = null;
  var DATOS_ACTUALES = null;
  var ELEGIDOS = [];
  var CANTIDAD = 1;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // 🔒 TAREA ADHESIVO (H3): la MISMA lógica en las DOS rutas — CON y SIN
  // variantes — para que subir la cantidad en el selector nativo antes de bajar
  // se respete siempre, no sólo cuando el producto no tiene variantes.
  function leerCantidadNativa() {
    var qtyInput = document.querySelector('input[name="quantity"]:not([type="hidden"])');
    if (!qtyInput) return 1;
    var n = parseInt(qtyInput.value, 10);
    return (n > 0) ? n : 1;
  }

  // 🔓 EXCEPCIÓN DECLARADA (H2, ver cabecera del archivo): único punto donde este
  // archivo escribe en el picker NATIVO — sólo DESPUÉS de un POST exitoso, para
  // avisarle a Dawn de una elección que el cliente ya hizo en NUESTRA ventanita.
  // Nunca se usa para RESOLVER nada (eso sigue siendo 100% leerVariantes +
  // resolverVariante). `elegidos[i]` tiene que venir en el MISMO orden que
  // `datos.opciones` (el orden en que aparecen los fieldsets/selects en el DOM) —
  // es el mismo orden que ya usa `resolverVariante`.
  function sincronizarPickerNativo(datos, elegidos) {
    try {
      var cajaRadios = document.querySelector('variant-radios');
      var cajaSelect = cajaRadios ? null : document.querySelector('variant-selects');
      if (!cajaRadios && !cajaSelect) return;
      var disparar = null;
      if (cajaRadios) {
        var fieldsets = cajaRadios.querySelectorAll('fieldset');
        for (var i = 0; i < fieldsets.length && i < elegidos.length; i++) {
          if (elegidos[i] == null) continue;
          var inputs = fieldsets[i].querySelectorAll('input[type="radio"]');
          for (var j = 0; j < inputs.length; j++) {
            var marcar = inputs[j].value === elegidos[i];
            if (inputs[j].checked !== marcar) inputs[j].checked = marcar;
            if (marcar) disparar = inputs[j];
          }
        }
      } else {
        var drops = cajaSelect.querySelectorAll('.product-form__input--dropdown');
        for (var k = 0; k < drops.length && k < elegidos.length; k++) {
          if (elegidos[k] == null) continue;
          var sel = drops[k].querySelector('select');
          if (!sel) continue;
          if (sel.value !== elegidos[k]) sel.value = elegidos[k];
          disparar = sel;
        }
      }
      // Un solo 'change', con burbujeo, sobre el ÚLTIMO nodo tocado: Dawn
      // (`VariantSelects.onVariantChange`) relee el fieldset ENTERO al recibirlo,
      // así que no hace falta uno por cada opción.
      if (disparar) disparar.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) { /* el tema no vive en este repo: si cambia, que falle en silencio */ }
  }

  function construirModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'satc-modal';
    modal.hidden = true;
    modal.setAttribute('data-satc-modal', '1');
    modal.innerHTML =
      '<div class="satc-modal__bg" data-satc-cerrar></div>'
      + '<div class="satc-modal__box" role="dialog" aria-modal="true" aria-label="Elegir variante">'
      + '<button type="button" class="satc-x" data-satc-cerrar aria-label="Cerrar">×</button>'
      + '<div data-satc-opciones></div>'
      + '<div class="satc-cant">'
      + '<span class="satc-cant__lbl">Cantidad</span>'
      + '<button type="button" class="satc-cant__btn" data-satc-menos aria-label="Menos">–</button>'
      + '<span class="satc-cant__val" data-satc-cant>1</span>'
      + '<button type="button" class="satc-cant__btn" data-satc-mas aria-label="Más">+</button>'
      + '</div>'
      + '<button type="button" class="satc-agregar" data-satc-agregar>Agregar</button>'
      + '<p class="satc-aviso" data-satc-aviso hidden></p>'
      + '</div>';
    document.body.appendChild(modal);
    contOpciones = modal.querySelector('[data-satc-opciones]');
    elCant = modal.querySelector('[data-satc-cant]');
    btnAgregar = modal.querySelector('[data-satc-agregar]');
    elAviso = modal.querySelector('[data-satc-aviso]');

    modal.addEventListener('click', function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('[data-satc-cerrar]')) cerrarModal();
    });
    contOpciones.addEventListener('click', function (ev) {
      var chip = ev.target && ev.target.closest ? ev.target.closest('[data-satc-opt]') : null;
      if (!chip || chip.disabled) return;
      var i = parseInt(chip.getAttribute('data-satc-opt'), 10);
      var v = chip.getAttribute('data-satc-val');
      if (!(i >= 0)) return;
      ELEGIDOS[i] = v;
      pintarOpciones();
      revisarVariante();
    });
    modal.querySelector('[data-satc-menos]').addEventListener('click', function () {
      if (CANTIDAD > 1) { CANTIDAD--; elCant.textContent = String(CANTIDAD); }
    });
    modal.querySelector('[data-satc-mas]').addEventListener('click', function () {
      CANTIDAD++; elCant.textContent = String(CANTIDAD);
    });
    btnAgregar.addEventListener('click', function () {
      if (!DATOS_ACTUALES) return;
      var variante = resolverVariante(DATOS_ACTUALES, ELEGIDOS);
      if (!variante || variante.available === false) return;   // el botón ya está apagado
      var datosParaSincronizar = DATOS_ACTUALES, elegidosParaSincronizar = ELEGIDOS.slice();
      agregarAlCarrito(variante.id, CANTIDAD, btnAgregar, function (ok) {
        if (ok === false) {
          elAviso.hidden = false;
          elAviso.textContent = 'No se pudo agregar · intenta de nuevo';
          return;
        }
        sincronizarPickerNativo(datosParaSincronizar, elegidosParaSincronizar);
        // Caso 8/10: ya no se cierra la ventanita aquí — se queda mostrando
        // «Agregado ✓» hasta que `agregarExitoso` se lleva a la página a `/cart`.
        agregarExitoso(btnAgregar);
      });
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !modal.hidden) cerrarModal();
    });
  }

  function pintarOpciones() {
    var out = '';
    for (var i = 0; i < DATOS_ACTUALES.opciones.length; i++) {
      var op = DATOS_ACTUALES.opciones[i];
      out += '<div class="satc-opt"><p class="satc-opt__nombre">' + esc(op.nombre) + '</p><div class="satc-opt__chips">';
      for (var j = 0; j < op.valores.length; j++) {
        var v = op.valores[j];
        out += '<button type="button" class="satc-chip' + (ELEGIDOS[i] === v.valor ? ' is-activo' : '') + '"'
          + (v.agotado ? ' disabled' : '')
          + ' data-satc-opt="' + i + '" data-satc-val="' + esc(v.valor) + '">' + esc(v.texto) + '</button>';
      }
      out += '</div></div>';
    }
    contOpciones.innerHTML = out;
  }

  // 🔒 ALTO-2: una vez que `agregarExitoso` puso el pestillo, ningún chip vuelve
  // a tocar el botón (ver el comentario junto a `yendoAlCarrito`, sección C).
  function revisarVariante() {
    if (yendoAlCarrito) return;
    var variante = resolverVariante(DATOS_ACTUALES, ELEGIDOS);
    var disponible = !!variante && variante.available !== false;
    btnAgregar.disabled = !disponible;
    if (disponible) {
      elAviso.hidden = true;
    } else {
      elAviso.hidden = false;
      elAviso.textContent = 'Esa combinación no está disponible';
    }
  }

  function abrirModal(datos) {
    construirModal();
    DATOS_ACTUALES = datos;
    ELEGIDOS = datos.opciones.map(function (op) {
      var def = null;
      for (var i = 0; i < op.valores.length; i++) { if (op.valores[i].elegido) { def = op.valores[i]; break; } }
      if (!def) def = op.valores[0];
      return def ? def.valor : null;
    });
    // 🔒 H3: respeta la cantidad del selector nativo si existe — el MISMO criterio
    // que ya usa la rama SIN variantes (sección E), en vez de reiniciar a 1.
    CANTIDAD = leerCantidadNativa();
    elCant.textContent = String(CANTIDAD);
    pintarOpciones();
    revisarVariante();
    modal.hidden = false;
  }

  function cerrarModal() {
    if (modal) modal.hidden = true;
  }

  /* ═══════════════════════════════════════════════════════════════════════
     (E) EL CLIC DEL BOTÓN ADHESIVO
     ═══════════════════════════════════════════════════════════════════════ */
  btnBar.addEventListener('click', function () {
    var datos = leerVariantes();
    if (datos) { abrirModal(datos); return; }
    // SIN variantes: se agrega directo. La cantidad la respeta el selector nativo
    // si existe (el cliente pudo haberla subido antes de bajar); sin selector, 1.
    var qty = leerCantidadNativa();
    barMsg.hidden = true;
    agregarAlCarrito(idInput.value, qty, btnBar, function (ok) {
      if (ok === false) { mostrarErrorBarra(); return; }
      agregarExitoso(btnBar);
    });
  });
})();
